import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _get from 'lodash/get';

import SiteComponent from '../SiteComponent/SiteComponent';
import FooterLinksConnected from './components/FooterLinks';
import actions from '../../actions/OrderAction';
import analyticsActions from '../../actions/AnalyticsAction';
import { showLazy } from '../../lazy/actions/LazyAction';
import {
    selectFeatureFlags,
    selectDeviceType,
    selectPreferences,
} from '../../selectors/ContextSelector';
import { selectExternalStaticBasePath } from '../../selectors/fromState';
import styles from './index.css';
import config from './config';
import footerNavigationAction from '../../actions/FooterNavigationAction';
import { CHECKOUT_PAGE_URL, CART_PAGE_SIGNIN_URL, COOKIES } from '../../common/Constants';
import {
    shouldLoadOneTrust,
    loadOneTrust,
    isExternalFooter,
} from '../../helpers/Utils/oneTrustUtils';

export class YodaFooter extends SiteComponent {
    static defaultProps = {
        actions,
        deviceType: {},
        expandedFooter: false,
        footerMenus: {},
        renderRecZone: () => null,
        enableFooterAppBanner: false,
        externalStaticBasePath: '',
        enableIrisFooterApi: false,
        footerLinkMenus: [],
        isNative: false,
        plccAnalyticsTagName: '',
        oneTrustScript: {},
    };

    static propTypes = {
        actions: PropTypes.object,
        deviceType: PropTypes.object,
        expandedFooter: PropTypes.bool,
        footerMenus: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
        enableFooterAppBanner: PropTypes.bool,
        externalStaticBasePath: PropTypes.string,
        enableIrisFooterApi: PropTypes.bool,
        isNative: PropTypes.bool,
        footerLinkMenus: PropTypes.array,
        plccAnalyticsTagName: PropTypes.string,
        oneTrustScript: PropTypes.object,
    };

    constructor() {
        super();
        this.state = {
            shouldInitiateRender: false,
            shouldLoadOneTrustScript: true,
        };
    }

    hydrateOnMount() {
        const { enableIrisFooterApi } = this.props;
        this.setState({
            shouldInitiateRender: true,
        });
        if (enableIrisFooterApi && !__SERVER__) {
            this.props.actions.getIrisFooterGlobalNavigationAction();
        }
    }

    loadOneTrustOnExernalSite() {
        const { url = '', key = '', enableOn = [] } = this.props.oneTrustScript;
        /* istanbul ignore next */
        const canLoadOneTrust =
            isExternalFooter(window?.__FRAGMENT__PRELOAD__) &&
            enableOn?.length > 0 &&
            shouldLoadOneTrust(window?.location?.hostname, enableOn);
        /* istanbul ignore next */
        if (canLoadOneTrust) {
            const loadParams = {
                src: url,
                key,
                async: false,
                defer: true,
                onSuccess: () => console.log('OneTrust Script loadded Successfully'),
                onError: () => console.log('Error received during OneTrust Script load'),
            };
            loadOneTrust(loadParams);
            this.setState({
                shouldLoadOneTrustScript: false,
            });
        }
    }

    render() {
        if (!this.state.shouldInitiateRender) {
            return null;
        }
        const {
            footerMenus = {},
            expandedFooter,
            deviceType,
            renderRecZone,
            enableFooterAppBanner,
            externalStaticBasePath,
            footerLinkMenus,
            enableIrisFooterApi,
            isNative,
            plccAnalyticsTagName,
        } = this.props;

        const cookieVisibleStatus =
            !__SERVER__ &&
            (window.location.pathname === CHECKOUT_PAGE_URL ||
                window.location.pathname === CART_PAGE_SIGNIN_URL);
        let footerMenuContent = '';
        /* istanbul ignore next */
        if (cookieVisibleStatus) {
            const Privacy = footerMenus.Privacy.filter((x) => x.text !== COOKIES);
            const updatedPrivacy = { Privacy };
            footerMenuContent = { ...footerMenus, ...updatedPrivacy };
        } else {
            footerMenuContent = footerMenus;
        }

        return (
            !isNative && (
                <>
                    <footer
                        className={styles.footerWrap}
                        data-automation-id="jcp-footer"
                        id="footer"
                    >
                        {typeof renderRecZone === 'function' && (
                            <div data-automation-id="footer-reczones" className={styles.recZone}>
                                {renderRecZone()}
                            </div>
                        )}
                        <FooterLinksConnected
                            expandedFooter={expandedFooter}
                            deviceType={deviceType}
                            footerMenus={footerMenuContent}
                            enableFooterAppBanner={enableFooterAppBanner}
                            externalStaticBasePath={externalStaticBasePath}
                            footerLinkMenus={footerLinkMenus}
                            enableIrisFooterApi={enableIrisFooterApi}
                            plccViewAnalyticsActions={this.props.actions.plccViewsAnalytics}
                            plccApplyAnalyticsActions={this.props.actions.plccApplyAnalytics}
                            plccAnalyticsTagName={plccAnalyticsTagName}
                        />
                    </footer>
                    {!__SERVER__ &&
                        this.state.shouldLoadOneTrustScript &&
                        this.loadOneTrustOnExernalSite()}
                </>
            )
        );
    }
}

export const mapStateToProps = (store) => {
    const featureFlags = selectFeatureFlags(store);
    const isNative = _get(store, 'context.isNative');
    const preferences = _get(store, 'context.preferences');
    const enableIrisFooterApi = _get(featureFlags, 'enableIrisFooterApi', false);

    return {
        deviceType: selectDeviceType(store),
        footerMenus: _get(selectPreferences(store), 'footer', config),
        enableFooterAppBanner: featureFlags.enableFooterAppBanner || false,
        externalStaticBasePath: selectExternalStaticBasePath(store),
        enableIrisFooterApi,
        footerLinkMenus: store.IrisFooterGlobalNavigation,
        plccAnalyticsTagName: _get(preferences, 'plccAnalyticsTagName', 'PLCC'),
        isNative,
        oneTrustScript: _get(preferences, 'oneTrustScript', {}),
    };
};

export const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        Object.assign(analyticsActions, footerNavigationAction, actions, { showLazy }),
        dispatch
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(YodaFooter);
